<p-dialog header="{{ triggerDialogHeader }}" [(visible)]="displayTriggerPopup" (onHide)="dialogCLose()" [modal]="true"
    [responsive]="true" [style]="{ width: '50vw' }">
    <div class="card">
        <form [formGroup]="timeTriggerForm" novalidate>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-4 p-md-2">
                        <p-inputNumber formControlName="occurrenceValue" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
                            placeholder="0"></p-inputNumber>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p-dropdown [options]="occurrenceBases" formControlName="occurrenceBase" appendTo="body" placeholder="Select" optionLabel="name"></p-dropdown>
                    </div>
                    <div class="p-col-6 p-md-3">
                        <p-dropdown [options]="addOrSubstractBases" formControlName="selectedAddOrSubstractBase" appendTo="body" placeholder="Select" optionLabel="name"></p-dropdown>
                    </div>
                    <div class="p-col-6 p-md-3">
                        <p-dropdown [options]="startBaseFields" formControlName="startDateBaseField" appendTo="body" placeholder="Select" optionLabel="name"></p-dropdown>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="dialogCLose()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton (click)="saveTriggerTimeValue()" label="Save"></button>
    </p-footer>
</p-dialog>
